import { runInitCommand } from "./commands/init";

async function main(): Promise<void> {
  const [, , command] = process.argv;

  if (!command || command === "init") {
    await runInitCommand();
    return;
  }

  console.error(`Unknown command: ${command}`);
  process.exitCode = 1;
}

main().catch((error) => {
  console.error("[go-offline/cli] Command failed.", error);
  process.exitCode = 1;
});
